import { render } from "./prescriptionQuery.vue?vue&type=template&id=4ec43090&scoped=true"
import script from "./prescriptionQuery.vue?vue&type=script&lang=js"
export * from "./prescriptionQuery.vue?vue&type=script&lang=js"

import "./prescriptionQuery.vue?vue&type=style&index=0&id=4ec43090&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4ec43090"

export default script